export default "__VITE_ASSET__DXqfs2PO__"